import { http } from ".."
import { getClassPayload } from "./class-interface"

export const createClass = (data: any) => {
	return http.post('/classes', data)
}

export const editClass = (data: any, classId: string) => {
	return http.patch(`/classes/${classId}`, data)
}

export const deleteClass = (classId: string) => {
	return http.delete(`/classes/${classId}`)
}

export const getClasses = (data: getClassPayload, teacherId: string) => {
	return http.get(`/classes/teacher/${teacherId}`, {
		params: {
			...data
		}
	})
}

export const getStudentClasses = (data: getClassPayload, studentId: string) => {
	return http.get(`/classes/student/${studentId}`, {
		params: {
			...data
		}
	})
}

export const joinClass = (classCode: string) => {
	return http.post(`/classes/join/${classCode}`, {})
}

export const getClass = (classId: string) => {
	return http.get(`/classes/${classId}`)
}


export const addStudentToClass = (classId: string, studentEmail: string) => {
	return http.patch(`/classes/add-student/${classId}/${studentEmail}`, {})
}

export const addTeacherToClass = (classId: string, teacherEmail: string) => {
	return http.patch(`/classes/add-teacher/${classId}/${teacherEmail}`, {})
}

export const getStudents = (teacherId: string) => {
	return http.get(`/classes/get-students/${teacherId}`, {})
}